/* istanbul ignore file */

export const MAP_DEFAULTS = {
    DEFAULT_MAP_PIN_URL: 'assets/icons/Pin.svg',
    DEFAULT_MAP_ZOOM: 4,
    DEFAULT_MAP_CENTER: { lat: 39.550053, lng: -98.5795 },
    DEFAULT_MAP_MIN_ZOOM: 3,
    DEFAULT_MAP_MAX_ZOOM: 21,
};
